import { graphql } from "react-relay";

export const weekInReviewScrubberFragments = {
  rewindHistory: graphql`
    fragment WeekInReviewScrubber_rewindHistory on RewindHistory {
      id
      snapshotDurationMillis
      snapshots {
        snapshotMillis
        days {
          workingHours {
            amBits
            pmBits
          }
          meetings {
            amBits
            pmBits
          }
          focusTime {
            amBits
            pmBits
          }
          lunch {
            amBits
            pmBits
          }
          fragmented {
            amBits
            pmBits
          }
        }
      }
    }
  `,
};
